<template>
  <div>
    <StyledTableReport
      idTable="total-reports"
      title="Concentrado Estacionamiento <br> Comisión Boletaje"
      :titleColspan="headersPlace.length"
      :details="detailsTotals"
      :headers="headersTotals"
      :total="totalCuota"
      :showIVA="true"
      :includeSubtotal="true"
      :showTotals="false"
      :center="true"
    >
      <template v-for="itemTotals in detTotales">
        <tr
          v-if="itemTotals.sitio !== 'Sumatoria'"
          :key="`item-totals-place-${itemTotals.sucursal}`"
        >
          <td>
            {{ itemTotals.sitio }}
          </td>
          <td align="right">
            ${{ $formatPrice(itemTotals.totalF) }}
          </td>
          <td align="right">
            ${{ $formatPrice($getSubtotal(itemTotals.cuotaF)) }}
          </td>
        </tr>
      </template>
    </StyledTableReport>

    <StyledTableReport
      v-for="place in detSitios"
      :key="`place-report-${place.sucursal}`"
      :idTable="`details-place-${place.sucursal}`"
      :titleColspan="headersPlace.length"
      :details="[
        { key: 'Parador', value: place.sitio, attrs: {class: 'pb-2'} },
        {
          key: 'Fecha',
          value: `${$formatFecha(dateStart)} al ${$formatFecha(dateEnd)}`
        }
      ]"
      :totals="{ tickets: place.Cantidad, canje: place.Canje, totalTickets: place.Total, total: place.totalF }"
      titleTable="Informe de ventas"
      :headers="headersPlace"
      :total="place.cuotaF"
      :showIVA="true"
      :includeComission="true"
      :spacer="true"
    >
      <tr
        v-for="ticketPlace in place.tickets"
        :key="`place-report-${place.sucursal}-ticket-${ticketPlace.IDNodoCuentaContable}-${ticketPlace.Cuenta}-${ticketPlace.PrecioIndividual}`"
      >
        <td>{{ ticketPlace.Cuenta }}</td>
        <td>{{ ticketPlace.Concepto }}</td>
        <td align="center">
          {{ $formatNum(ticketPlace.Cantidad) }}
        </td>
        <td align="center">
          {{ $formatNum(ticketPlace.Canje) }}
        </td>
        <td align="center">
          {{ $formatNum(ticketPlace.total) }}
        </td>
        <td align="right">
          ${{ $formatPrice(ticketPlace.PrecioIndividual) }}
        </td>
        <td align="right">
          ${{ $formatPrice(ticketPlace.Importe) }}
        </td>
        <td align="right">
          ${{ $formatPrice($getSubtotal(ticketPlace.promtec), decimalsOnReport) }}
        </td>
        <td align="right">
          ${{ $formatPrice($getSubtotal(ticketPlace.cuotaX)) }}
        </td>
      </tr>
    </StyledTableReport>

    <div v-if="detMayo.length">
      <StyledTableReport
        idTable="title-wholesalers"
        :details="detailsWholesalers"
        :headers="[]"
        :spacer="true"
        :showTotals="false"
        :showTable="false"
      />
      <StyledTableReport
        idTable="subtitle-wholesalers"
        :headers="headersReportWholesalers"
        :showTotals="false"
        center
      >
        <tr
          v-for="cashierData in detUserMayo"
          :key="'cashier-data-'+cashierData.name"
        >
          <td>
            {{ cashierData.name }} {{ cashierData.name2 }} {{ cashierData.name3 }}
          </td>
          <td
            align="center"
            class="text-center"
          >
            {{ $formatNum(cashierData.operaciones) }}
          </td>
          <td
            align="right"
            class="text-right"
          >
            ${{ $formatPrice(cashierData.total) }}
          </td>
        </tr>
        <tr class="spacer-styled-table">
          <th
            align="right"
            class="text-right"
            style="border-top: 2px double black;"
          >
            Totales:
          </th>
          <th
            align="center"
            class="text-center"
            style="border-top: 2px double black;"
          >
            {{ $formatNum(getTotalOperaciones) }}
          </th>
          <th
            align="right"
            class="text-right"
            style="border-top: 2px double black;"
          >
            ${{ $formatPrice(getTotalCashiers) }}
          </th>
        </tr>
      </StyledTableReport>

      <StyledTableReport
        v-for="(placeWholesalers, index) in detMayo"
        :key="`place-wholesalers-${placeWholesalers.sitioId}`"
        :idTable="'details-place-wholesalers-' + placeWholesalers.sitioId"
        :title="placeWholesalers.sitio"
        center
        :headers="headersWholesalers"
        :includeCajes="false"
        :includeComission="true"
        :totals="{totalTickets: placeWholesalers.cantidadSitio, total: placeWholesalers.total }"
        :total="placeWholesalers.cuota"
        :spacer="!!index"
      >
        <tr
          v-for="ticketPlace in placeWholesalers.tickets"
          :key="`place-wholesalers-${placeWholesalers.sitioId}-ticket-${ticketPlace.id_ticket}-${ticketPlace.costo}`"
        >
          <td>
            {{ ticketPlace.nombre }}
          </td>
          <td align="center">
            {{ $formatNum(ticketPlace.cantidad) }}
          </td>
          <td align="right">
            ${{ $formatPrice(ticketPlace.costo) }}
          </td>
          <td align="right">
            ${{ $formatPrice(ticketPlace.total) }}
          </td>
          <td align="right">
            ${{ $formatPrice($getSubtotal(ticketPlace.promtec), decimalsOnReport) }}
          </td>
          <td align="right">
            ${{ $formatPrice($getSubtotal(ticketPlace.cuotaX)) }}
          </td>
        </tr>
      </StyledTableReport>

      <StyledTableReport
        idTable="footer-place-wholesalers"
        :details="[]"
        :headers="[]"
        :spacer="true"
        :showTotals="false"
        showIVA
        includeSubtotal
        :lettersColspan="headersWholesalers.length"
        :total="totalCuotaMayo"
      />
    </div>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import StyledTableReport from '../tools/reports/StyledTableReport.vue'

export default {
  name: 'ReportCommissionsTable',
  components: { StyledTableReport },
  props: [
    'dateStart',
    'dateEnd',
    'detTotales',
    'totalCuota',
    'detSitios',
    'detMayo',
    'detUserMayo',
    'totalCuotaMayo'
  ],
  data () {
    return {
      decimalsOnReport: 6,
      detailsTotals: [
        {
          key: 'Fecha',
          value: `${this.$formatFecha(this.dateStart)} al ${this.$formatFecha(this.dateEnd)}`,
          attrs: { class: 'pt-2' }
        }
      ],
      headersTotals: [
        { name: 'Parador', attrs: { class: 'text-left' } },
        { name: 'Recaudación', attrs: { width: '25%' } },
        { name: 'Comisión', attrs: { width: '25%' } }
      ],
      headersPlace: [
        { name: 'Cuenta', attrs: { width: '10%' } },
        { name: 'Concepto', attrs: { width: '20%', class: 'text-left' } },
        { name: 'Vendidos', attrs: { width: '7.5%' } },
        { name: 'Canjes', attrs: { width: '5%' } },
        { name: 'Total', attrs: { width: '7.5%' } },
        { name: 'Precio Individual', attrs: { width: '10%' } },
        { name: 'Importe', attrs: { width: '15%' } },
        { name: 'Comisión por boleto', attrs: { width: '10%' } },
        { name: 'Comisión total', attrs: { width: '15%' } }
      ],
      headersReportWholesalers: [
        { name: 'Cajero', attrs: { } },
        { name: 'Total de transacciones', attrs: { } },
        { name: 'Total', attrs: { } }
      ],
      detailsWholesalers: [
        { key: 'Parador', value: 'WEB MAYORISTAS' },
        {
          key: 'Fecha',
          value: `${this.$formatFecha(this.dateStart)} al ${this.$formatFecha(this.dateEnd)}`
        }
      ],
      headersWholesalers: [
        { name: 'Nombre del Boleto', attrs: { } },
        { name: 'Cantidad', attrs: { width: '14%' } },
        { name: 'Precio Unitario', attrs: { width: '14%' } },
        { name: 'Costo', attrs: { width: '14%' } },
        { name: 'Comisión por boleto', attrs: { width: '14%' } },
        { name: 'Comisión total', attrs: { width: '14%' } }
      ]
    }
  },
  computed: {
    getTotalOperaciones: function () {
      let total = 0
      this.detUserMayo.forEach(element => {
        total += element.operaciones
      })
      return total
    },
    getTotalCashiers: function () {
      let total = 0
      this.detUserMayo.forEach(element => {
        total += element.total
      })
      return total
    }
  },
  methods: {
    convertTablesOnPDF: function (consecutive, titulox) {
      const didParseCell = function (didParseCell) {
        if (didParseCell.cell.raw.className.includes('total-for-jspdf')) {
          didParseCell.cell.styles.fontStyle = 'bold'
        }
        if (didParseCell.cell.raw.className.includes('total-write-for-jspdf')) {
          didParseCell.cell.styles.halign = 'center'
          didParseCell.cell.styles.valign = 'middle'
        }
      }
      const startY = 35

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        format: 'a4',
        orientation: 'landscape'
      })

      this.addPage(doc, consecutive, false)
      doc.autoTable({
        html: '#total-reports-header',
        startY,
        styles: {
          halign: 'center'
        }
      })
      doc.autoTable({
        html: '#total-reports',
        theme: 'grid',
        headStyles: {
          halign: 'center'
        },
        columnStyles: {
          1: { halign: 'right' },
          2: { halign: 'right' }
        },
        didParseCell
      })

      const self = this
      this.detSitios.forEach(element => {
        self.addPage(doc, consecutive)
        doc.autoTable({
          html: '#details-place-' + element.sucursal + '-header',
          startY
        })
        doc.autoTable({
          html: '#details-place-' + element.sucursal,
          theme: 'grid',
          headStyles: {
            halign: 'center'
          },
          columnStyles: {
            2: { halign: 'right' },
            3: { halign: 'right' },
            4: { halign: 'right' },
            5: { halign: 'right' },
            6: { halign: 'right' },
            7: { halign: 'right' },
            8: { halign: 'right' }
          },
          didParseCell,
          willDrawCell: function (hookData) {
            if (hookData.pageCount > 1 && hookData.row.index === 0) {
              doc.autoTable({
                html: '#details-place-' + element.sucursal + '-header',
                startY
              })
              hookData.cursor.y = 50
            }
          },
          didDrawPage: function (data) {
            self.addPage(doc, consecutive, false)
          },
          margin: { top: 35, bottom: 20 }
        })
      })

      if (this.detMayo.length) {
        this.addPage(doc, consecutive)
        doc.autoTable({
          html: '#title-wholesalers-header',
          startY
        })
        doc.autoTable({
          html: '#subtitle-wholesalers',
          styles: {
            halign: 'right',
            cellPadding: 0.5
          },
          theme: 'plain'
        })
        this.detMayo.forEach((element, index) => {
          const validate = index !== 0 && index !== 2 && index !== 4
          if (validate) {
            this.addPage(doc, consecutive)
          }
          doc.autoTable({
            html: '#details-place-wholesalers-' + element.sitioId + '-header',
            startY: validate ? startY : null
          })
          doc.autoTable({
            html: '#details-place-wholesalers-' + element.sitioId,
            theme: 'grid',
            headStyles: {
              halign: 'center'
            },
            columnStyles: {
              1: { halign: 'right' },
              2: { halign: 'right' },
              3: { halign: 'right' },
              4: { halign: 'right' },
              5: { halign: 'right' }
            },
            didParseCell
          })
        })
        doc.autoTable({
          html: '#footer-place-wholesalers',
          theme: 'grid',
          styles: {
            halign: 'right',
            fontStyle: 'bold'
          },
          columnStyles: {
            0: { cellWidth: 195 }
          },
          didParseCell
        })
      }

      doc.save(titulox)
      // var data = doc.output('datauristring');
      // window.open(data,'_blank');
    },
    addPage: function (doc, consecutive, notFirtsPage = true) {
      const imgPromtec = 'data:image/jpeg;base64,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'
      const imgTicket2Pass = 'data:image/jpeg;base64,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'
      const imgFooter = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAA/ALgDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9U6KKKACiiigAooooAK4HXviZeWHjKfw7p2j2t9eQxQzC3utTS0ubxX3FjaxshEoRUbJLoMqR2zXfVwvjz4fal44iv7CXWbP+w72NVNne6UtxJbMAVaS3lDpsYg5BdXKtyDjgAEWq/FC4h8Vz+HdL0YalqH2hbeB5LryYWYRCWYu+xtgjV4+gYkuBgda6HTdY1nUNFu5H0WOz1i3laEWtxdMLeUgjDpMIyxQg8HywcgjHeubj+FU1jDYXVhrPkeILO+ub0ahPbmaObz2w8cke8FhsEa5Dg/uwc9Qeq8NaNe6TBdPqWqSatf3Uxmlk2GOGPgKqRRFm8tAqjjJJO5iSTQBj+APGGseMDqMl7o9jptrZ3dxYl7fUXuHaaGQxt8pgQBCQSDnPTgdoNF8fap4geHULHw95/hma8+yxXy3f+lMu7y/P+z7MCLeDz5m7b8xXtWl4Z8J3Phezvoba/ila81a41F2ltycJNMZGjADjkA4D9O+3tWTpvw61LSVj0uz8RtbeF4rv7VHZQ27Jdqm7zPI+0iT/AFW/P8G4p8pbvQB2Gq6guk6dcXbQXF0Il3eTaxGWVz2VVHUk/gOpIGTXmt58briLwdoWuweH1/4mi3LGO6vvKjiaIkLF5gjYNLIRhEwNxBAPFenWS3MdrGt3LFPcgfPJDEY0PPZSzEfma8yPwTuLfQ9Js7PXokubGyvdPaW70/z4nhuX3OVj8wbHGAN245AIIIOKANLTfisdY8ey+G7e00+1khWBpI9S1LyL1vMhEzCO2Ebbiin5vmHfnioPCPxQ1rxn9risvDVtDdwxpLsudRdUiJdlaCdhATFcKFVjFtbhhyO8mofCe61K10nSJ/EEknhzTZYJoLdrVReKYYgiKLgMBt3DecxliSw3YIAy9I+FKacl9o7eJ7RtT/4R3+xbSO3tFikgtCzATSR+YTI24/eGxchuMk0Ablv8SrxfhfqnjC80WOFbWKa5t7eG8Z0uoUHySK7RKVV8ZGU+6Qe+Klb4y+FoppreS8n+2Qh1khjs52HmpEZWhWTZsaTaCQoOTxgc1r+KfB8PiDwLqHhm2lGnW9zZNZRyKm8QqV2jC5GcDtmuWf4MiS1MDaucHXG1kkW3ram38r7/AL7t34Y70AaGgfGLQNX0jR7q5kmsLi/tba4kha2meO1M3CLLL5YVAzZCs+0OMEcEU3/hdHhppoJEv0TTGhupnvLmC4hBEBQP5W6HbJhm2nDAg4ADEkDmtP8A2fUspbGSXUNLvJIrWytZp7rQ455ttsNqmBpHYRF4wqtlX5G5dpxixf8AwDj1Hw9o2lya26jTYL6JZo7YAs888cyPgscBGjGV53DPK0AdTF8WfDE81tBHeXLXdxcPapaDT7n7QJUVWdWi8veuFYN8wAxz0BNO8cfES28G6hoVh9nN9fapfQWvko+3yYpJVjMzHB4DOoA6sTx0JGVpPwqubXxpbeKNQ1pL3VFuJp7hYbPyYn3wJAiopkYoFVB1LEknpS/EL4caD4m1bTbu71SbSdTmvbTaw1CaP7UsDmRYUjEqruwZCGUblLMw5oA9CooooAKKK42T4nWS3V75Wl6nc6ZZXn2C51aGOM28UwZVZdpcSsFZgpZYyoOecKxAB2VeR+Lv+EZ/4WJq3/CwfsP9k/2dD/Y/9sbfs2Mv9p8rd8vnZ8rP8e3bt4zXa+IvHSaDr+n6LDo+o6xqF7BLcxx2JgUKkZUMWMsqDq69M1peFvEln4v0Cz1exEi21ypISZdrxsrFXRh/eVlZTgkZHBI5oA8ZvPiJrVhfJb2mp6hpzQx6X/ZGi6pBHJdarFM5ErSkhpGZV6lGBXbl8kmu4+At3A/wv0K1WaNrmO3aR4Qw3qjTShWI6gEo4B77T6GrGm/Fyx1i4WKx0fVrkXH2gWEm2BF1AwuEl8rfKMYzn95syAcZxinWXxSOoxXX2bwn4gnuLa7eye3jjtnO9EDSHzBOYwFyF5cEsdoBKtgA8S33mjeGNpEk+lax4vyDjP2e6j1LntwrxqPYNGe71sR/GfxNJoj/AGTUY73VbXQ7ye9h8mPdbTpfxReY4VCUMcLu20jGAGZT39MsfjfoGpS2H2aDUJLS5FqJb0wqsVo9wWWGOXcwYMWUg7VYDIyQCDWzoPxAtte8QSaQNN1Kwn+ztdwSXsSIlzCsnlmRAHLKMkEB1UkEHFAHlCfEzxZpmjvqCava+JLaS5uNJtnsNtwpupIla1Pmi3hWQiUMhMYK4kAI3Lk3pPiRrOn/ABR0nQhrk11HHqMWmX9veJbxGTNsW81YUjMgVmKMJDKoLMVWMqCR3MPxg0OW18XTmK8jHhmVobtHjXdKwLKPKAY5DMpUZ28jnFWdP+JNhq2oeGYLd7WFNb08aikd5fRRXSoyho1WDJZ2bL5I+UeW3zE8UAedfGCHQbbxPq19fXWi6lepZQMdD18SW87IvmEHTrkHKOx4IjVyXUAlTis/xH8XtZsfFkdtp+oXNjGkv2afS9REHmQ5s2kUiPy2lI3GM+a8oDMSoRhkj16H4leG7q6mSDWtNntYbdrma+j1C3aGIBlBDfvNw++pzt28jJyQDW034teFb+xur2TWbPT7KG8exS5vrqKKK4dVVi0Tb8MpDgg/pQBzfwn8Ta/qGswWesau+rx3vh2x1oNLbxRGGSZpA6L5arlPlH3snjrXHeIviK+peLrzxF4fuJLG2GlafY6heyRLJJpIe+lEvmp8yrIi5JVs46nivbdW8UWmj3GkLMkr22pzi3ivItrQpIwzGHOcgP0UgEZwCRkZq6T480jVhcP562cMck6RTXckca3SQkCaWL5stGpOCxAHfoQSAeI658V/E2n2sVxH4mR9Nhu7qK1uY7eAXGqRLMipKivGIrkAErsheJjncM8V0fgfxjreofFy+t7u80y3aa7u7W50ng3aQQg+RIVS3DKMFSHlmKMJW2gHAHq0fi/QptQjsE1rTnvpIhcJbLdxmVoyu4OFzkrt5z0xzWJqHxg8IWMdjJHr2n6gl3ex2KtY3cUoSR84LEPwoxkmgDiPEDeE08WeN28deR9vAiOk/atvm/Zfs42/YN3zeb5vnZ8v5t+z/ZrmtH1vxD4dm1K+0q/vI47/AMTzWDaTdW0Ukhc6f5gd2wWMoZEGA23IPBzXsOn/ABJ0a61DXYp9U0e1ttMlWPzf7VhdyDtVmkQH90BI2wBjkkdBxm5qXjzRrLwfqHia3vI9W0qyhkmeXTZUm3BBlgpDbSfbNAHgHiH4pXPib/hFQfEkSWsNvotzeXkMUTC1vHeUTyH5cBlXaSp+VSOV6itC8+M3iHS9M1mW411fsq6VqJ0bUZbaJBqM0NwFjlT5drtsblVG0gbtuOa9Zl+L2iRweEZRHeSf8JNII7RUjXdEcqG835vl2s6qcZ59au6D8QtM1q61GNr7SoY7e+WxgaLVIpnmZh8u5VPyMzBgqEljtPA6UAeZ2vizxVqr2r/8JPdWou/FraLshtbUiK3WCST5d0RO/IHzEkcDjrnltX+LurnSPDd+2pqNetrRJ2aeC2jSZWu3hkKAwvI7NHGS4jMSoASW5Cj31viBoEd1eo+q2MdtZwrLPetfQCGMmVotjfPuUh1xllC5OASQQLLeMvD8cmnI2u6ar6kFNkpu4wboEgAxDPz5JGNuetAGzRRRQAV55Y+F/F2gW19o2j3Wmw6XcahLd2+pySN9ptIpZvNkjEBiZJCC0gVi44Zcj5cH0OigDg/EHw/uvFfjfR9XvpDaWVja3ds8en6jcQTMXlQxMHi2HBRMsucAnHzY3V1OhaPB4dtItL0+zhtNJtYUW3EcjM+7LbwwI/3TvLEsWbOMZbTooA8r0f4W6lp3jKLWFh02zi09b17OG2vLl4pZZ2OGMD5W2XBJZYidzHPYCr9x4P8AEel+A9C8PaK1m4SHy9WlkvpLeSYlcyeVKIZCpeRmJbaGAJ27SQy+i0UAeRzfCrWZdQMdvHpemaNfPpcl5bwXEkj2osmysUOYgHVgkQ3HZtw3DcVuaP4N1w/ENfEOoppNisdvNbzS6S0gk1PLKImnRlAXYi8DdIQScNjivQKKAPF5fgjq8niS4vRf2cdnfanc3d9CHcmaETLParjb95ZAd2TgBuM9DBoXwN1bSdS0l53sb63jTSnuHbUbyIQSWkKRMI4IyqS5MasruRtLHKkcH2+igDwqP4E67DpPh+JbrTGn0nTUgMLvIYLidL6K5CuNmTEwjIJxkEg4OKn1D4S+ML6x1KFLjS7NNVvtQuru3tb6aMKLiOJYz5qxB3CMjs0fyLJ8u444Ht1YfjXXrrwz4Zv9RstOm1O4ghd1ihMY24Qne290yoxyAd3oDQBmXng+6vPhO3hlzb/2j/ZAslkLMYkuFhCq4bbuAVwGDYyMAgZrnvGHw11i+svDkWijTU/s7R7vSJIrmV4kVZ4oow6bY2zs8v7pAyD1FYfifX9c8SaTo+vSwnT7Ow0mfUr7Rf7efTbm6XZG3nIbZpCYxhgodl5b5sVsafE+veLtEvvD2ra7Kvmi71Nrq7drW3t2t8paGInyzId0Z4BdeWdssu4Ap6T8LfEmi2Vzp0KeHrqG4EU41DUEe4nt5ksVt9qRmPaQGX5WLcIzDYc1naf8IPF0Wqf2nd3On3N41/pl9L52pTzF2thKJfnaL5d/mBgqqFXJUAAAl/xI1bXtF8ZX19bXF5eCO60uHT4rPUlSC33y4lhntg4aR5cnB2P8pBDLtOOVutW8X2imxt9Wuf7S1CxvpLvUpNajktbgLdRhJLU+YVtsqzQqSIvmkUYyu4AG5dfBHxfq0k8uo3umXE0lmtkzteTMjKl7BOpWLygkS+XEU8tBjIBJYsSOzu/htqU3gn4gaOk1oLnxBeXdxasXbYiyoir5h25BypzgH8ap+BNa1O40Hx9b+ZcaZDptzLFYza5fee1qfs6Mwln3PlUclidzbQ2MnbWPo1zq9j4U8VaGmoXFlr+l6Zb3Vxqy6rPqyXCNFId0TTYELsUY4C4AYEA8EADZvgPq0+pO7alaizhvYZLEI7h7eBneW5AG3G4yONo6YQZI6UaP8Fdds9Dk02ZdLR5NPh0dr/8AtK8upRAr5eWNJcpEyhVKRqMK53BwFCnD8TeKNTXTNEvE1vU4W0zwzp+p3bx3LpsLyrmYJvAu3bYymOTCgHO4sdp0LPWbq88dXMlx4l1TTtK1G+1awFyLrbsWFMsvkuxjtxEImKzAF2/iCbuQC+Pg34ig1XSr6J9GY6LDZQ2sIkkjS7+zzztukxGfKZkmDEjfiRT1HNTan8IvEGpR3kXl+H7VNYsrezvBbCRE0/y7mSXNsmz5wwkyQxTMi7+M4E1lZrDY6pqN9qniWDwvPeRnSNN+33H268fyipCsW+0BXb51j3rjYWYBSa5TUtQ8T+HrO6j1nXL6DW9E0/S3solvWxO015Ir+aoIFwwRUiJYMM5PVt1AH0XRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBmaz4Z0fxH5H9raTY6p9nYtD9stkm8snGSu4HB4HT0qqvgTw1HrH9rL4e0pdU8wzfbhZRCfzD1fft3bvfOa3aKAM658OaTeavb6rcaXZz6pbrshvpLdGniXnhXI3AfM3Q9z61FD4R0K3fUni0XT431MMt8yWsYN0GzuEvHz53NndnOT61rUUAU9N0bT9H01NPsLG2sbBAwW1toVjiUMSWAUAAZJJPHc1W0vwpomh2NxZabo+n6fZ3GfOt7W1SKOTIwdyqADkcc9q1aKAMm48JaHeSadJPo2nzSabt+xPJaxsbXbjb5RI+TG1cbcYwPSo7jwX4eury9uptB0ya6vo/KuppLONnuE+U7ZGK5YfKvBz90elbVFAHMf8ACrvBghMI8I6F5JYOY/7Nh2lgCAcbeuCfzq7F4J8OwNp7RaDpkbafn7Gy2cYNtk7j5fy/Jzz8uOa2qKACiiigD//Z'

      if (notFirtsPage) doc.addPage()

      // Headers
      doc.setFontSize(12)
      doc.setFont(undefined, 'bold')
      doc.setTextColor('#444')
      doc.text(228, 25, 'No. Reporte: ' + consecutive)
      doc.text(50, 30, 'SERVICIO INTEGRAL DE ACUERDO CON EL CONTRATO CULTUR/CPSBE-PC-02/030/2021')

      const pageSize = doc.internal.pageSize
      const pageWidth = pageSize.width || pageSize.getWidth()

      doc.addImage(imgPromtec, 'JPEG', 15, 6.6, 26.9, 9.3)
      doc.addImage(imgTicket2Pass, 'JPEG', pageWidth - 15 - 36.45, 6.6, 36.45, 6.8)

      // Footers
      doc.addImage(imgFooter, 'JPEG', pageWidth - 15 - 46.8, 190, 46.8, 16.02)

      const currentPage = doc.internal.getCurrentPageInfo()
      const { pageNumber } = currentPage

      doc.setFontSize(8)
      doc.setFont(undefined, 'normal')
      doc.setTextColor('#888')
      doc.text(15, 202.04, `${pageNumber}`)
    }
  }
}
</script>

<style scoped>
</style>
